// Import model
import { SelectFieldOptions } from '../models/SelectFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)
import { ReferenceFieldOptionsSerializer } from './ReferenceFieldOptionsSerializer';
import { MultiSelectFieldOptionsSerializer } from './MultiSelectFieldOptionsSerializer';

/**
 * Serializer for SelectFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class SelectFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a SelectFieldOptions instance
   */
  static deserialize(json: string): SelectFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SelectFieldOptions instance
   */
  static fromObject(obj: any): SelectFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SelectFieldOptions');
    }


    const instance: SelectFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      items: obj['Items'] as string | undefined,
      allowUnknown: obj['AllowUnknown'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SelectFieldOptions instances
   */
  static deserializeArray(json: string): SelectFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SelectFieldOptions instance to a JSON string
   */
  static serialize(instance: SelectFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SelectFieldOptions instance to a plain object
   */
  static toObject(instance: SelectFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Items': instance.items,
      'AllowUnknown': instance.allowUnknown,
    };
  }

  /**
   * Serializes an array of SelectFieldOptions instances to a JSON string
   */
  static serializeArray(instances: SelectFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
